/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Forside_Preview_TaskInputs */

const da_forside_preview_task = /** @type {(inputs: Forside_Preview_TaskInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Opgave ${i?.number}`)
};

/** @type {(inputs: Forside_Preview_TaskInputs) => LocalizedString} */
const en_forside_preview_task = da_forside_preview_task;

/**

* @param {Forside_Preview_TaskInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_preview_task = /** @type {((inputs: Forside_Preview_TaskInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Preview_TaskInputs, { locale?: "da" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_preview_task(inputs)
	return da_forside_preview_task(inputs)
});